import { Aspect } from '@teambit/harmony';

export const HarmonyUiAppAspect = Aspect.create({
  id: 'teambit.ui-foundation/harmony-ui-app',
});
